import { render, staticRenderFns } from "./LibraryRoomHourForm.vue?vue&type=template&id=513c050d"
import script from "./LibraryRoomHourForm.vue?vue&type=script&lang=js"
export * from "./LibraryRoomHourForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports